module.exports = __webpack_public_path__ + "img/49.89071091.jpg";